// extracted by mini-css-extract-plugin
export default {"shareToAppModal":"ShareToAppModal_shareToAppModal__WHwnW","shareToAppCloseIcon":"ShareToAppModal_shareToAppCloseIcon__sPPaC","shareIcon":"ShareToAppModal_shareIcon__5XfrP"};